"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _warning = _interopRequireDefault(require("warning"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      href = _ref.href,
      fullWidth = _ref.fullWidth,
      kind = _ref.kind,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      onMouseDown = _ref.onMouseDown,
      target = _ref.target,
      type = _ref.type,
      restOfProps = _objectWithoutProperties(_ref, ["children", "className", "disabled", "href", "fullWidth", "kind", "onClick", "onKeyDown", "onMouseDown", "target", "type"]);

  /**
   * Use `button` with disabled prop instead of `a` tag when "disabled" prop is
   * set to true, since the disabled prop does not exist for anchor tags.
   */
  var Component = href && !disabled ? 'a' : 'button';
  var buttonClasses = (0, _classnames.default)(className, {
    'pds-button': true,
    'pds-button--primary': kind === 'primary',
    'pds-button--secondary': kind === 'secondary',
    'pds-button--tertiary': kind === 'tertiary',
    // TODO: Remove once mixins support line-height options
    'pds-button--tertiary--base': kind === 'tertiary',
    'pds-button--anchor': Component === 'a',
    'pds-button--full-width': fullWidth
  });
  var buttonProps = {};
  /**
   * Anchor tags with button-like features have specific requirements (ie. role)
   * whereas only native buttons have certain properties (ie. type, disabled)
   */

  if (Component === 'button') {
    /**
     * Type should only be used on native button elements, as types for
     * anchor tags is a "media_type"
     */
    buttonProps.type = type;
    buttonProps.disabled = disabled; // Due to onBlur shifts the DOM elements we need:
    // Add a e.preventDefault() to an onMouseDown event handler
    // Add a onClick property that sets the e.target.focus()

    buttonProps.onClick = function (e) {
      e.target.focus();
      onClick(e);
    };

    buttonProps.onMouseDown = function (e) {
      e.preventDefault();
      onMouseDown(e);
    };
  } else {
    // TODO: Create a property to handle "media_type" type for anchor tags
    buttonProps.role = 'button';
    buttonProps.href = href;
    buttonProps.target = target;

    buttonProps.onKeyDown = function (e) {
      onKeyDown(); // Handle Spacebar

      if (e.keyCode === 32) {
        e.preventDefault();
        window.open(href, target);
      }
    };
  }

  var ariaLabel = restOfProps['aria-label'] || restOfProps['aria-labelledby'];

  if (!ariaLabel) {
    (0, _warning.default)(ariaLabel, 'PDS::BUTTON: "aria-label" or "aria-labelledby" should be included as a prop, but none was found. See the Button documentation for more info: (https://github.tlcinternal.com/pages/UITools/ui-propulsion/#/components/button)');
  }

  return _react.default.createElement(Component, _extends({}, restOfProps, buttonProps, {
    className: buttonClasses
  }), children);
};

Button.propTypes = {
  /**
   * Applies additional CSS classes to the component.
   */
  className: _propTypes.string,

  /**
   * Text or child elements of the button.
   */
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.node), _propTypes.node]).isRequired,

  /**
   * Whether or not the button is clickable.
   */
  disabled: _propTypes.bool,

  /**
   * Set to true to have the width of the button fill the parent container.
   */
  fullWidth: _propTypes.bool,

  /**
   * Link to external page; if prop is specified, DOM element will become
   * <a> instead of <button>.
   */
  href: _propTypes.string,

  /**
   * The kind of button to display.
   */
  kind: _propTypes.string,

  /**
   * Event handlers passed down to the native HTML, the event fires when
   * the user clicks on button.
   */
  onClick: _propTypes.func,

  /**
   * Event handlers passed down to the native HTML, the event fires when
   * the user presses a keyboard key.
   */
  onKeyDown: _propTypes.func,

  /**
   * Event handler passed down to the native HTML, the event fires when
   * the mouse key is pressed but not yet released.
   */
  onMouseDown: _propTypes.func,

  /**
   * Specifies how to open the link; only applied when the href prop is used.
   */
  target: _propTypes.string,

  /**
   * The type of button.
   */
  type: (0, _propTypes.oneOf)(['button', 'reset', 'submit'])
};
Button.defaultProps = {
  className: '',
  disabled: false,
  href: '',
  fullWidth: false,
  kind: 'primary',
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  onMouseDown: function onMouseDown() {},
  target: '_blank',
  type: 'button'
};
var _default = Button;
exports.default = _default;
